module.exports = __webpack_public_path__ + "img/video.1f5aeb0b.svg";